import { CARE_PLAN_SERVICE_KEY, CarePlanServiceKey, Sku } from '@/api';

export const QUALITY_REVIEW_SKU: Sku[] = [] as const;

export const QUALITY_REVIEW_SERVICE_CODE: CarePlanServiceKey[] = [
  CARE_PLAN_SERVICE_KEY.IMAGING_BASE_ADVANCE_HEART,
  CARE_PLAN_SERVICE_KEY.IMAGING_BASE_ADVANCE_NEURO,
  CARE_PLAN_SERVICE_KEY.IMAGING_BASE_BODY_COMPOSITION,
] as const;
